import { api } from "@/lib/api";

const UTM_KEY = "fm_utm";

// Capture UTM params from the current URL once and persist for the session so
// later events (submission, etc.) can be attributed even after navigation.
export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const source =
      params.get("utm_source") || params.get("source") || params.get("ref") || null;
    const campaign = params.get("utm_campaign") || params.get("campaign") || null;
    if (source || campaign) {
      const existing = getUtm();
      const merged = {
        source: source || existing.source || null,
        campaign: campaign || existing.campaign || null,
      };
      sessionStorage.setItem(UTM_KEY, JSON.stringify(merged));
      return merged;
    }
  } catch (e) {
    /* ignore */
  }
  return getUtm();
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem(UTM_KEY) || "{}");
  } catch (e) {
    return {};
  }
}

// Fire-and-forget. Analytics failures must never block the UI.
export function track(event, props = {}) {
  try {
    const utm = getUtm();
    api
      .post("/analytics/event", {
        event,
        props,
        source: utm.source || null,
        campaign: utm.campaign || null,
        path: typeof window !== "undefined" ? window.location.pathname : null,
      })
      .catch(() => {});
  } catch (e) {
    /* never throw */
  }
}
